import { Component, computed, input, model, output } from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { NgIcon } from '@ng-icons/core';
import { Button } from '../button/button';

@Component({
  selector: 'ui-file-input',
  imports: [NgIcon, Button],
  templateUrl: './file-input.html',
})
export class FileInput implements FormValueControl<File | { url: string } | null> {
  icon = input<string>('heroPhotoSolid');
  rounded = input<'lg' | 'full'>('lg');
  accept = input<string>();

  imageUrl = computed(() => {
    const value = this.value();
    if (value instanceof File) {
      return URL.createObjectURL(value);
    }
    if (value && typeof value === 'object' && 'url' in value) {
      return value.url;
    }
    return null;
  });

  readonly value = model<File | { url: string } | null>(null);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);

  fileChange = output<File | null>();

  onFileInputChange(files: FileList | null) {
    this.revokeImageUrl();

    const file = files?.[0] ?? null;
    this.value.set(file);
    this.touched.set(true);
    this.fileChange.emit(file);
  }

  onImageLoad() {
    this.revokeImageUrl();
  }

  private revokeImageUrl() {
    const objectUrl = this.imageUrl();
    if (objectUrl !== null) {
      URL.revokeObjectURL(objectUrl); // free memory
    }
  }
}
